module.exports = __webpack_public_path__ + "AdityaSharma-d8a5cbff.webp";